module.exports = __webpack_public_path__ + "static/media/02-print-ad.8370f353.png";